module.exports = __webpack_public_path__ + "assets/img/12_108.f55e587d.jpg";